import { useLocation } from '@reach/router';
import {
  Wrapper,
  FixedWrapper,
  Title,
  AnchorWrapper,
  StyledLink,
  StyledTextLink,
} from './TableOfContents.styles';

const TableOfContents = ({ links }: { links: Queries.AnchorHeadingFragment[] }) => {
  const { hash } = useLocation();

  return (
    <Wrapper>
      <FixedWrapper>
        <Title>On this page</Title>
        <AnchorWrapper>
          {Boolean(links.length) &&
            links.map((link: Queries.AnchorHeadingFragment) => {
              const { title, url_slug, text_in_toc } = link.elements;
              const urlSlug = `#${url_slug.value}`;
              const isActive = urlSlug === hash;
              const text = text_in_toc?.value || title.value;

              return (
                <StyledLink to={urlSlug} key={link.system.codename}>
                  <StyledTextLink isActive={isActive}> {text}</StyledTextLink>
                </StyledLink>
              );
            })}
        </AnchorWrapper>
      </FixedWrapper>
    </Wrapper>
  );
};

export default TableOfContents;
